import React, { useState } from "react";
import {
	PaymentElement,
	useStripe,
	useElements
} from "@stripe/react-stripe-js";
import { getBaseMessagerieUrl } from "../../../../../../utils/baseUrl";

// eslint-disable-next-line react/prop-types
export default function CheckoutForm({ paymentType }) {

	const stripe = useStripe();
	const elements = useElements();

	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(null);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not yet loaded.
			// Make sure to disable form submission until Stripe.js has loaded.
			return;
		}

		setIsLoading(true);

		const { error } = await stripe.confirmPayment({
			elements,
			confirmParams: {
				// Une fois le paiement confirmé, stripe redirige vers une url avec des informations passé en paramètre GET
				// Ici on redirige vers la composant Home dans lequel se trouve un useEffect qui analyse l'url et
				// exécute du code en fonction des paramètre existant
				return_url: `${getBaseMessagerieUrl()}${paymentType === "oneTime" ? "/?payment=success" : "/?payment=success"}`,
			},
		});

		// This point will only be reached if there is an immediate error when
		// confirming the payment. Otherwise, your customer will be redirected to
		// your `return_url`. For some payment methods like iDEAL, your customer will
		// be redirected to an intermediate site first to authorize the payment, then
		// redirected to the `return_url`.
		if (error.type === "card_error" || error.type === "validation_error") {
			setErrorMessage(error.message);
		} else {
			setErrorMessage("Une erreur est survenue, veuillez essayer de nouveau");
		}

		setIsLoading(false);
	};

	// Ci-dessous, un trick qui change le padding du formulaire Element
	// Le formulaire ne s'affichait pas à cause d'une valeur height très petite
	// Le fait de changer le padding corrige cette valeur height pour la valeur normale
	const element = document.getElementById("payment-element");
	if (element) {
		element.style.padding = "1px";
		element.style.padding = "2px";
		element.style.padding = "3px";
	}

	// le <PaymentElement/> intègre une iframe avec un formulaire dynamique qui
	// collecte les détails de paiement pour une variété de méthodes de paiement.
	// Cela permet au user de choisir un type de mode de paiement. Le formulaire recueille automatiquement tous
	// les détails de paiement nécessaires pour le type de mode de paiement sélectionné par le client.
	return (
		<>
			<form id="payment-form" onSubmit={handleSubmit}>
				<PaymentElement id="payment-element" />
			</form>
			{errorMessage && <h1>{errorMessage}</h1>}
			{isLoading && <h1>Chargement</h1>}
		</>
	);
}